import { useRouter } from "next/router";
import React, { useContext, useEffect, useState, useTransition } from "react";
import { useForm } from 'react-hook-form'
import settingsModel from "../../models/settings.model";
import useSWR from 'swr'
import Heading from "../../components/Heading.js";
import Link from "next/link";
import SettingsLayout from "./SettingsLayout";
import Form from "react-bootstrap/Form";
import helper from "../../lib/helper";
const Page = function () {

    const router = useRouter()
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors,isSubmitting },
        setError,
        reset
    } = useForm();
    const { data, mutate } = useSWR('setting', async () => await settingsModel.list())
    useEffect(() => {
        reset(data?.data);
    }, [data])


    const onSubmit = handleSubmit(async (data, event) => {
        const formData = new FormData(event.target);
        await settingsModel.create(formData).then((response) => {
            helper.sweetalert.toast(response?.data?.message, 'success');
        }).catch(error => {
            setError('title', { type: 'required', message: error.response?.data?.errors?.title });
        })
    });

    return (
        <>
            <SettingsLayout title="Settings">
                <form onSubmit={onSubmit}>
                    <div className="card-header">Ecommerce Settings</div>
                    <div className="list-group list-group-flush">
                        <div className="list-group-item">
                            <div className="row align-items-center">
                                <div className="col">
                                    <strong className="mb-0">Allow COD</strong>
                                    {/*  <p className="text-muted mb-0">Donec in quam sed urna bibendum tincidunt quis mollis mauris.</p> */}
                                </div>
                                <div className="col-auto">
                                    <div className="custom-control custom-switch">
                                        <Form.Check
                                            type="switch"
                                            id="custom-switch"
                                            value={true}
                                            {...register('allow_cod')}
                                        />
                                        <span className="custom-control-label"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="list-group-item">
                            <div className="row align-items-center">
                                <div className="col">
                                    <strong className="mb-0">COD Charges</strong>
                                    <p className="text-muted mb-0">Cash on Delivery charge for COD Payments</p>
                                </div>
                                <div className="col-auto">
                                    <input type="number" {...register('cod_charges')} className="form-control" />
                                </div>
                            </div>
                        </div>
                        <div className="list-group-item">
                            <div className="row align-items-center">
                                <div className="col">
                                    <strong className="mb-0">Min Amount for Free COD</strong>
                                    <p className="text-muted mb-0">Mininum order amount required for Free COD</p>
                                </div>
                                <div className="col-auto">
                                    <input type="number" {...register('min_cod_amount')} className="form-control" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-footer text-end">
                        <button type="submit" disabled={isSubmitting ? 'disabled' : ''} className=" btn btn-primary">Save</button>

                    </div>
                </form>
            </SettingsLayout>
        </>
    );
};

export default Page;